import * as actionTypes from '../actions/actionTypes';

const initialState = {
    gameDocuments: [],
    groupedDocuments: {},
    postComplaint: {
        sent: false,
        response: [],
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.customerSupport.RECEIVED_GAME_DOCUMENTS:
            return {
                ...state,
                gameDocuments: action.items,
                groupedDocuments: action.groups,
            };
        case actionTypes.customerSupport.POST_COMPLAINT:
            return  {
                ...state,
                postComplaint: {
                    sent: true,
                    response: action.data,
                }
            };
        default:
            return state;
    }
};

export default reducer;
